/* Lorelia Buch-Gestalter · Abgabe (06.10.2026)
   1) Fotos + projekt.json in den Lorelia-Fotospeicher (Supabase „lorelia-uploads“, Frankfurt; nur Hochladen erlaubt, kein Lesen)
   2) Artikel mit versteckter Projekt-Nummer in den Warenkorb, dann zum Warenkorb.
   Das Druck-Skript (druck/lr_buch_bestellung.py) holt nach der Bestellung alles ab, baut die PDF und bestellt bei Gelato.
   Konfiguration: window.LR_BUCH_SPEICHER = { url, anon, bucket } (öffentlicher Schlüssel, Rechte per Richtlinie nur „hochladen“). */
(function () {
  'use strict';
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16); });
  }
  function hoch(S, pfad, daten, typ, versuch) {
    versuch = versuch || 1;
    return fetch(S.url.replace(/\/$/, '') + '/storage/v1/object/' + S.bucket + '/' + pfad, {
      method: 'POST', body: daten,
      headers: { apikey: S.anon, Authorization: 'Bearer ' + S.anon, 'Content-Type': typ, 'x-upsert': 'false', 'cache-control': '3600' }
    }).then(function (r) {
      if (r.ok) return true;
      if (versuch < 3 && r.status >= 500) return new Promise(function (ok) { setTimeout(ok, 1200 * versuch); }).then(function () { return hoch(S, pfad, daten, typ, versuch + 1); });
      return r.text().then(function (t) { throw new Error('Upload ' + r.status + ' ' + t.slice(0, 120)); });
    }, function (e) {
      if (versuch < 3) return new Promise(function (ok) { setTimeout(ok, 1500 * versuch); }).then(function () { return hoch(S, pfad, daten, typ, versuch + 1); });
      throw e;
    });
  }
  window.LRBuchAbgabe = function (projekt, dateien, format, stand) {
    var S = window.LR_BUCH_SPEICHER;
    if (!S || !S.url) return Promise.reject(new Error('Fotospeicher nicht eingerichtet'));
    var id = uuid(), fertig = 0, gesamt = dateien.length;
    projekt.id = id; projekt.erstellt = new Date().toISOString();
    stand('Fotos werden hochgeladen … 0 von ' + gesamt);
    var i = 0;
    function arbeiter() {
      if (i >= dateien.length) return Promise.resolve();
      var d = dateien[i++];
      return hoch(S, id + '/' + d.id + '.jpg', d.blob, 'image/jpeg').then(function () {
        fertig++; stand('Fotos werden hochgeladen … ' + fertig + ' von ' + gesamt); return arbeiter();
      });
    }
    return Promise.all([arbeiter(), arbeiter(), arbeiter()]).then(function () {
      stand('Fast fertig …');
      return hoch(S, id + '/projekt.json', new Blob([JSON.stringify(projekt)], { type: 'application/json' }), 'application/json');
    }).then(function () {
      var innen = projekt.seiten.length - 1;
      var props = { _lr_buch: id, _lr_buch_art: projekt.art };
      if (projekt.art === 'kalender') { props['Kalender'] = projekt.titel + ' · ab ' + ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'][projekt.start.monat] + ' ' + projekt.start.jahr; }
      else { props['Fotobuch'] = projekt.titel + ' · ' + innen + ' Seiten'; }
      props['Fotos'] = String(dateien.length);
      return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(format.variant, 10), quantity: 1, properties: props }] })
      }).then(function (r) { if (!r.ok) return r.text().then(function (t) { throw new Error('Warenkorb ' + r.status + ' ' + t.slice(0, 120)); }); return r.json(); });
    }).then(function () {
      stand('Im Warenkorb ✓');
      setTimeout(function () { location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart'; }, 500);
    });
  };
})();
